const taxRate = () => {
    const parsed = Number(process.env.REACT_APP_TAX_PERCENTAGE);
    return Number.isFinite(parsed) ? parsed : 0.15;
};

// Cart totals must not include a shipping charge or the IVA on that charge.
export const totalsWithoutShipping = ({
    totalPrice = 0,
    taxPrice = 0,
    shippingPrice = 0,
} = {}) => {
    const shipping = Number(shippingPrice);
    const tax = Number(taxPrice);
    const total = Number(totalPrice);
    const safeShipping = Number.isFinite(shipping) && shipping > 0 ? shipping : 0;
    const shippingTax = Number((safeShipping * taxRate()).toFixed(2));
    const safeTax = Number.isFinite(tax) ? tax : 0;
    const safeTotal = Number.isFinite(total) ? total : 0;

    return {
        taxPrice: Number(Math.max(0, safeTax - shippingTax).toFixed(2)),
        totalPrice: Number(Math.max(0, safeTotal - safeShipping - shippingTax).toFixed(2)),
    };
};

export const getExTaxItemsSubtotal = (items) => {
    const subtotal = (Array.isArray(items) ? items : []).reduce((sum, item) => {
        const price = Number(item?.price || 0);
        const qty = Number(item?.qty || 0);
        if (!Number.isFinite(price) || !Number.isFinite(qty)) {
            return sum;
        }
        return sum + price * qty;
    }, 0);

    return Number(subtotal.toFixed(2));
};

export const getFormattedPriceParts = (amount) => {
    const value = typeof amount === 'number' && !isNaN(amount) ? amount : 0;
    const [intPart, decimalPart] = value.toFixed(2).split('.');
    return [intPart, decimalPart];
};

export const taxMultiplier = (taxPercentage) => {
    const parsedTax = Number(taxPercentage);
    return 1 + (Number.isFinite(parsedTax) ? parsedTax : 0) / 100;
};

export const getProductPriceSummary = (product, userInfo) => {
    if (!product) {
        return {
            fullBasePrice: 0,
            finalPrice: 0,
            effectiveDiscount: 0,
            hasValidDiscount: false,
        };
    }

    let basePrice =
        userInfo?.priceAssigned === 'pvp_distribuidor' ? product.priceDist : product.price;

    if (basePrice === undefined || basePrice === null) {
        basePrice = product.price || product.priceDist || 0;
    }

    const parsedBasePrice = Number(basePrice);
    const safeBasePrice = Number.isFinite(parsedBasePrice) ? parsedBasePrice : 0;

    const now = new Date();
    const from = product.discountDateFrom ? new Date(product.discountDateFrom) : null;
    const to = product.discountDateTo ? new Date(product.discountDateTo) : null;

    const appliedDiscount = Number(product.appliedDiscountPercentage ?? 0);
    const hasAppliedDiscount = Number.isFinite(appliedDiscount) && appliedDiscount > 0;

    const legacyDiscount = Number(product.discount ?? 0);
    const hasValidLegacyDiscount =
        legacyDiscount > 0 && (!from || now >= from) && (!to || now <= to);

    const effectiveDiscount = hasAppliedDiscount
        ? appliedDiscount
        : (hasValidLegacyDiscount ? legacyDiscount : 0);
    const hasValidDiscount = effectiveDiscount > 0;

    const fullBasePrice = safeBasePrice * taxMultiplier(product.taxPercentage);
    const finalPrice = hasValidDiscount
        ? fullBasePrice * (1 - effectiveDiscount / 100)
        : fullBasePrice;

    return {
        fullBasePrice,
        finalPrice,
        effectiveDiscount,
        hasValidDiscount,
    };
};
